import { axios } from 'shared/services/axios'

export function updateEnrichment(type, enrichmentData, requestDuration) {
  return axios.post('/live_board/v2/enrichments', {
    type,
    request_duration: requestDuration,
    enrichment_data: enrichmentData
  })
}
